import { render } from "./MarketplaceHighlightsView.vue?vue&type=template&id=119ab649"
import script from "./MarketplaceHighlightsView.vue?vue&type=script&lang=js"
export * from "./MarketplaceHighlightsView.vue?vue&type=script&lang=js"

import "./MarketplaceHighlightsView.vue?vue&type=style&index=0&id=119ab649&lang=scss"

import exportComponent from "/opt/build/repo/energy-hub-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__